import {MouseEvent} from 'react';
import {twMerge} from '../../../common/twMerge';
import {ErrorAreaChildProps} from './ErrorAreaChildProps.interface';

interface ErrorTextButtonProps extends ErrorAreaChildProps {
  onClick?: (e: MouseEvent) => void;
}

export function ErrorAreaTextButton({
  onClick,
  children,
  className,
  ...props
}: ErrorTextButtonProps) {
  return (
    <div
      className={twMerge(
        'text-center underline whitespace-pre-wrap break-all font-small1 text-theme-solid-100 decoration-theme-solid-40',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}

export const ErrorAreaTextButtonType = (<ErrorAreaTextButton />).type;
